/**
 * Rutas de las landings por intención de búsqueda (TASK-153).
 * Lista liviana para App.js: el texto completo vive en seoPages.js y se carga solo con la página.
 * Un test verifica que coincida con KEYWORD_LANDINGS.
 */
export const KEYWORD_LANDING_SLUGS = [
  'crm-para-negocios',
  'sistema-de-turnos-online',
  'turnero-online',
  'agenda-online',
  'software-para-peluquerias',
  'software-para-psicologos',
  'software-para-odontologos',
  'software-para-kinesiologos',
  'software-para-nutricionistas',
  'software-para-medicos',
  'software-para-unas-y-manicura',
  'software-para-spa-y-masajes',
  'software-para-tatuadores',
  'software-para-entrenadores-personales',
  'software-para-peluquerias-caninas',
];

/**
 * Rubros de las landings pSEO /turnos-<rubro>-<ciudad>. Así App.js distingue esas URLs de la
 * página de un negocio cuyo slug empiece con "turnos-". Un test verifica que coincida con PSE_RUBROS.
 */
export const PSEO_RUBRO_SLUGS = [
  'padel', 'canchas', 'salud', 'barberias', 'fitness', 'estetica', 'veterinarias',
  'talleres', 'consultoria', 'academias', 'inmobiliaria', 'eventos', 'gaming',
];

export const isPseoLocationSlug = (slug = '') =>
  slug.startsWith('turnos-') && PSEO_RUBRO_SLUGS.some((rubro) => slug.startsWith(`turnos-${rubro}-`));
